var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAssetLibrary = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 28,
  height: 24,
  viewBox: "0 0 28 24",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M26 4a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2zm-2-4a2 2 0 0 1 2 1.999L5 2a3 3 0 0 0-2.995 2.824L2 5l-.001 17-.148-.005A2 2 0 0 1 0 20V4a4 4 0 0 1 4-4zm-5.567 14.21-.106.08-3.302 2.823-1.937-1.656-.108-.082a1.23 1.23 0 0 0-1.368 0l-.108.082-4.094 3.5-.087.082c-.677.696-.226 1.863.754 1.955l.125.006h15.596l.12-.005c.94-.086 1.411-1.17.822-1.885l-.083-.091-4.679-4.667-.1-.089a1.23 1.23 0 0 0-1.445-.054M10 8a2 2 0 1 0 0 4 2 2 0 0 0 0-4"
})));
export default SvgAssetLibrary;